import React from "react";
import style from "./index.module.scss";
import { Divider, Tooltip, Button, Modal, message } from "antd";
import { deletePolyvPlayBack, ScreenListItem } from "service/liveRecord";
import usePromiseCallback from "utils/usePromiseCallback";
import { errorMessage } from "service/service";
import { lookPlayback } from "service/CourseDetail/resource";

interface ListItemProps {
    data: ScreenListItem;
    onChange: () => void;
}

export default function ListItem({ data, onChange }: ListItemProps) {
    const openwatchUrl = usePromiseCallback(async function () {
        try {
            const result = await lookPlayback({
                channelId: data?.channelId + "",
                vid: data.vid
            });
            window.open(result?.watchUrl);
        } catch (e) {
            message.error(errorMessage(e));
        }
    });
    const onDelete = usePromiseCallback(async function () {
        Modal.confirm({
            title: `删除“${data.title}”？`,
            content: "直播回放删除后不可恢复，确定要删除吗？",
            onOk: async () => {
                try {
                    await deletePolyvPlayBack(data.vid);
                    message.success("删除成功!");
                    onChange();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        });
    });
    return (
        <div className={style.root}>
            <h1 className={style.title}>
                <Tooltip title={data?.title} placement="topLeft">
                    {data?.title}
                </Tooltip>
            </h1>
            <div className={style.info}>
                开始时间 {data?.startTime}
                <Divider type="vertical" />
                <span>视频时长 {data?.durationTime}</span>
            </div>
            <div className={style.links}>
                <div>
                    <Button type="link" onClick={openwatchUrl}>
                        预览
                    </Button>
                    {/* <Button type="link" onClick={info}>
                        组件预览
                    </Button> */}
                    <Button type="link" onClick={onDelete}>
                        删除
                    </Button>
                </div>
            </div>
        </div>
    );
}
